<script lang="ts">
    import { Router } from 'svelte-routing';
    import Fullscreen from './components/ui/functional/fullscreen.svelte';
    import Wrapper from './components/ui/wrapper.svelte';
    import LoadingAssets from './components/ui/functional/preload-assets.svelte';
    import GlobalLoading from './components/ui/global-loading.svelte';
    import BackgroundMusic from './components/ui/functional/background-music.svelte';
    import WelcomeScreens from './components/ui/welcome-screens.svelte';
    import Notifications from './components/ui/notifications/notifications.svelte';
    import { gameStatus, autoBetStarted, isLoading, gameState } from './store/index';
    import { ASSETS } from './constants/index';
    import { notifications } from './store/notifications.js';

    import {
        userSettings,
        skipWelcomeScreensAgain,
        showWelcomeScreens,
        toggleAllSounds,
        appStarted,
        currentTabMainMenu,
        updateUserSettings,
        isBetModalOpened,
        isAutoplayModalOpened,
        isCrossModalOpened
    } from './store/ui';

    import { exitUrl, gameInitParams } from './store/misc';
    import { initGameStates } from '@src/states';
    import Game from './Game.svelte';
    import Controls from './components/ui/controls.svelte';
    import ControlsActions from './components/ui/controls-actions/controls-actions.svelte';
    import FooterMobile from './components/ui/footer/footer-mobile.svelte';
    import MainMenu from './components/ui/menu/main-menu.svelte';
    import GameSessionHeader from './components/ui/header/game-session-header.svelte';
    import ModalsContainer from './components/ui/modal/modals-container.svelte';
    import './store/analytics';
    import BetHint from './components/ui/hint/bet-hint.svelte';
    import { gameStates } from './states/machine/state-types';
    import HistoryLine from './components/ui/header/history-line.svelte';
    import { gameHistory } from './store/game-history';

    initGameStates();
</script>

<Router url="">
    <GlobalLoading hidden={!$isLoading} />

    {#if $appStarted && !$showWelcomeScreens && $userSettings.musicEnabled}
        <BackgroundMusic gameStatus={$gameStatus} autoBetStarted={$autoBetStarted} />
    {/if}

    {#if $showWelcomeScreens}
        <WelcomeScreens
            soundEnabled={$userSettings.musicEnabled || $userSettings.soundEnabled}
            skipAgain={$skipWelcomeScreensAgain}
            on:close={() => ($showWelcomeScreens = false)}
            on:skip-again={event => ($skipWelcomeScreensAgain = event.detail)}
            on:toogle-mute={event => toggleAllSounds(event.detail)}
        />
    {/if}

    <Fullscreen let:onToggle>
        <Wrapper>
            <!-- @TODO MainMenu need encapsulation -->
            <MainMenu
                musicEnabled={$userSettings.musicEnabled}
                soundEnabled={$userSettings.soundEnabled}
                currentTab={$currentTabMainMenu}
                on:fullscreen={onToggle}
                on:musicChange={e => updateUserSettings({ musicEnabled: e.detail })}
                on:soundChange={e => updateUserSettings({ soundEnabled: e.detail })}
                slot="main-menu"
            />
            <svelte:fragment slot="header">
                <GameSessionHeader />
                <HistoryLine results={$gameHistory} />
            </svelte:fragment>
            <Game slot="video" />
            <Controls
                showAboveModals={$isBetModalOpened || $isAutoplayModalOpened || $isCrossModalOpened}
                slot="controls"
            >
                <svelte:fragment slot="status">
                    {#if $gameState === gameStates.game && $gameStatus === 'STARTED'}
                        <BetHint />
                    {/if}
                </svelte:fragment>
                <ControlsActions />
                <FooterMobile slot="footer" />
            </Controls>

            <ModalsContainer />
            <Notifications notifications={$notifications} />
        </Wrapper>
    </Fullscreen>

    <!-- <SpineComponent></SpineComponent> -->
    <LoadingAssets assets={ASSETS} />
</Router>
